import React, { useEffect, useRef, useState } from 'react'
import 'antd/lib/style/index.css'
import zhCN from 'antd/lib/locale/zh_CN'
import css from './user-center.module.less'
import {
  Button,
  Card,
  ConfigProvider,
  Input,
  message,
  Modal,
  Radio,
  Upload,
} from 'antd'
import { sendHttpPostRequest } from '../../../api/http-request'
import type { DraggableData, DraggableEvent } from 'react-draggable'
import { BACKEND_API_URL } from '../../../constants/constants'
import Draggable from 'react-draggable'
import Cookies from 'js-cookie'

interface Props {}

export const MyBasicInfo: React.FC<Props> = () => {
  const [pwdModalVisible, setPwdModalVisible] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const draggleRef = useRef<HTMLDivElement>(null)

  const [userInfo, setUserInfo] = useState({} as any)
  const [nickName, setNickName] = useState('')
  const [realName, setRealName] = useState('')
  const [introduction, setIntroduction] = useState('')
  const [sex, setSex] = useState(1)
  const [sexLabel, setSexLabel] = useState('')
  const [isUserLogin, setIsUserLogin] = useState(false)
  const [userHeaderImg, setUserHeaderImg] = useState('')
  const [editMode, setEditMode] = useState(false)
  const [imgFileList, setImgFileList] = useState([] as any)

  const currentPwd = useRef('')
  const newPwd = useRef('')
  const newPwdConfirm = useRef('')

  useEffect(() => {
    queryUserInfo()
  }, [])

  const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
    const { clientWidth, clientHeight } = window.document.documentElement
    const targetRect = draggleRef.current?.getBoundingClientRect()
    if (!targetRect) {
      return
    }
    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    })
  }

  const showModal = () => {
    document.getElementById('show-login-modal')?.click()
  }

  const queryUserInfo = () => {
    sendHttpPostRequest('account/api/get_user_info/', {}, (data) => {
      data.code == -100 ? showModal() : setIsUserLogin(true)

      if (data.is_ok == true) {
        setUserInfo(data.data)
        setRealName(data.data.real_name)
        setNickName(data.data.nick_name)
        setIntroduction(data.data.introduction)
        setSex(data.data.sex_number)
        setSexLabel(data.data.sex)
        setUserHeaderImg(data.data.avatar)
      } else {
        message.error(data?.message)
      }
    })
  }

  const updateUserInfo = () => {
    if (!nickName.trim()) {
      message.error('昵称不能为空')
      return
    }

    sendHttpPostRequest(
      'account/api/update_user_info/',
      {
        nick_name: nickName,
        real_name: realName,
        introduction,
        sex,
      },
      (data) => {
        if (data.is_ok) {
          setEditMode(false)
          queryUserInfo()
          message.success('个人信息已更新')
        } else {
          message.error(data?.message || '保存失败，请稍后重试')
        }
      }
    )
  }

  const onSexChange = (event: any) => {
    setSex(event.target.value)
    if (event.target.value == 2) {
      setSexLabel('男')
    } else if (event.target.value == 3) {
      setSexLabel('女')
    } else {
      setSexLabel('未设置')
    }
  }

  const onOkToChangePwd = () => {
    if (currentPwd.current.trim() == '') {
      message.error('请输入当前密码')
    } else if (currentPwd.current.length < 6 || currentPwd.current.length > 20) {
      message.error('当前密码长度6-20位')
    } else if (newPwd.current.trim() == '') {
      if (newPwd.current.length > 0) {
        message.error('新密码不能都是空格')
      } else {
        message.error('请输入新密码')
      }
    } else if (newPwdConfirm.current.trim() == '') {
      message.error('请输入新密码确认')
    } else if (newPwdConfirm.current != newPwd.current) {
      message.error('两次输入的新密码输入不一致')
    } else if (newPwdConfirm.current == currentPwd.current) {
      message.error('新旧密码不能相同')
    } else if (newPwdConfirm.current.length < 6 || newPwdConfirm.current.length > 20) {
      message.error('密码长度6-20位')
    } else {
      sendHttpPostRequest(
        '/account/api/change_password/',
        {
          current_password: currentPwd.current,
          new_password: newPwd.current,
          new_password_confirm: newPwdConfirm.current,
        },
        (data) => {
          message.destroy()
          if (data.is_ok) {
            setPwdModalVisible(false)
            currentPwd.current = ''
            newPwd.current = ''
            newPwdConfirm.current = ''
            message.success('密码修改成功，下次登录请使用新密码')
          } else {
            message.error(`密码修改失败：${data.message}`)
          }
        }
      )
    }
  }

  const onImageChange = (info: any) => {
    setImgFileList(info.fileList)
    const { status } = info.file
    if (status === 'done') {
      const newAvatar = BACKEND_API_URL + info.file.response.img_url
      document.getElementById('user-avatar')?.setAttribute('src', newAvatar)
      document.getElementById('header-user-avatar')?.setAttribute('src', newAvatar)
      document.getElementById('pop-user-avatar')?.setAttribute('src', newAvatar)
      document.getElementById('info-avatar')?.setAttribute('src', newAvatar)
      setUserHeaderImg(info.file.response.img_url)
    } else if (status === 'error') {
      message.error(`${info.file.name} file upload failed.`)
    }
  }

  const beforeImageUpload = (file: any) => {
    const maxSize = 5 * 1024 * 1024
    if (file.size > maxSize) {
      setImgFileList([])
      message.error('上传文件大于5M,换一个试试呢')
      return false
    }
    return true
  }

  const uploadData = {
    sessionid: Cookies.get('sessionid'),
    sid: Cookies.get('sessionid'),
  }

  const replaceCoverHandler = () => {
    document.getElementById('replace-cover')?.click()
  }

  return (
    <Card
      bodyStyle={{ color: '#333' }}
      style={{ position: 'relative', border: 'none', boxShadow: 'none' }}
    >
      <div className={css.infoFieldGroup}>
        <div className={css.infoField}>
          <div className={css.infoLabel}>账号</div>
          <div className={css.infoValue}>
            {userInfo?.register_type == 1 ? userInfo?.phone : userInfo?.email}
          </div>
        </div>

        <div className={css.infoField}>
          <div className={css.infoLabel}>昵称</div>
          <div className={css.infoValue}>
            {editMode ? (
              <Input
                value={nickName}
                onChange={(event) => setNickName(event.target.value.toString())}
                placeholder="请输入昵称（必填）"
              />
            ) : (
              <span>{nickName || '未设置'}</span>
            )}
          </div>
        </div>

        <div className={css.infoField}>
          <div className={css.infoLabel}>头像</div>
          <div className={css.infoValue}>
            {isUserLogin && !editMode && (
              <img
                className={css.avatar}
                src={BACKEND_API_URL + userHeaderImg}
                alt="头像"
                id="info-avatar"
              />
            )}
            {isUserLogin && editMode && (
              <div className={css.imgContain}>
                <Upload
                  action={BACKEND_API_URL + 'account/api/upload_header_image/'}
                  maxCount={1}
                  accept=".jpg,.jpeg,.png"
                  listType="picture-card"
                  name="avatar"
                  fileList={imgFileList}
                  onChange={onImageChange}
                  beforeUpload={beforeImageUpload}
                  data={uploadData}
                  showUploadList={false}
                >
                  <span id="replace-cover"></span>
                  <img
                    id="user-avatar"
                    className={css.avatar}
                    src={BACKEND_API_URL + userHeaderImg}
                    height="80px"
                    width="80px"
                  />
                </Upload>
                <div className={css.previewMask} onClick={replaceCoverHandler}>
                  <div className={css.maskText}>更换头像</div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className={css.infoField}>
          <div className={css.infoLabel}>真实姓名</div>
          <div className={css.infoValue}>
            {editMode ? (
              <Input
                value={realName}
                onChange={(event) => setRealName(event.target.value.toString())}
                placeholder="请输入真实姓名"
              />
            ) : (
              <span>{realName || '未设置'}</span>
            )}
          </div>
        </div>

        <div className={css.infoField}>
          <div className={css.infoLabel}>个人简介</div>
          <div className={css.infoValue}>
            {isUserLogin &&
              (editMode ? (
                <Input.TextArea
                  value={introduction}
                  rows={4}
                  onChange={(event) => setIntroduction(event.target.value.toString())}
                  placeholder="请输入个人简介"
                />
              ) : (
                <span>{introduction || '无'}</span>
              ))}
          </div>
        </div>

        <div className={css.infoField}>
          <div className={css.infoLabel}>性别</div>
          <div className={css.infoValue}>
            {isUserLogin &&
              (editMode ? (
                <Radio.Group onChange={onSexChange} value={sex}>
                  <Radio value={2}>男</Radio>
                  <Radio value={3}>女</Radio>
                </Radio.Group>
              ) : (
                <span>{sexLabel || '未设置'}</span>
              ))}
          </div>
        </div>
      </div>

      <div className={css.fixdBtnContain}>
        <Button
          onClick={() => setPwdModalVisible(true)}
          type="default"
          hidden={!isUserLogin}
          className={`${css.btnStyle} ${css.btnDefault}`}
          style={{ marginRight: '25px' }}
        >
          修改密码
        </Button>
        <Button
          className={`${css.btnStyle} ${css.btnPrimary}`}
          style={{ marginLeft: '25px' }}
          type="primary"
          hidden={!isUserLogin}
          onClick={() => {
            if (editMode) {
              updateUserInfo()
            } else {
              setEditMode(true)
            }
          }}
        >
          {editMode ? '保存' : '编辑'}
        </Button>
      </div>

      <ConfigProvider locale={zhCN}>
        <Modal
          title={
            <div
              style={{ width: '100%', cursor: 'move' }}
              onMouseOver={() => {
                if (disabled) {
                  setDisabled(false)
                }
              }}
              onMouseOut={() => {
                setDisabled(true)
              }}
              onFocus={() => {}}
              onBlur={() => {}}
            >
              修改密码
            </div>
          }
          className={css.ModalTip}
          open={pwdModalVisible}
          onOk={onOkToChangePwd}
          onCancel={() => setPwdModalVisible(false)}
          modalRender={(modal) => (
            <Draggable
              disabled={disabled}
              bounds={bounds}
              onStart={(event, uiData) => onStart(event, uiData)}
            >
              <div ref={draggleRef}>{modal}</div>
            </Draggable>
          )}
        >
          <div className={css.pwdModalBody}>
            <div className={css.pwdModalField}>
              <div className={css.pwdModalLabel}>当前密码</div>
              <Input
                className={css.modalInput}
                placeholder="请输入当前密码"
                onChange={(event) => {
                  currentPwd.current = event.target.value
                }}
                type="password"
                maxLength={20}
                minLength={6}
              />
            </div>
            <div className={css.pwdModalField}>
              <div className={css.pwdModalLabel}>新密码</div>
              <Input
                className={css.modalInput}
                placeholder="请输入新密码，6-20位"
                onChange={(event) => {
                  newPwd.current = event.target.value
                }}
                type="password"
                maxLength={20}
                minLength={6}
              />
            </div>
            <div className={css.pwdModalField}>
              <div className={css.pwdModalLabel}>确认密码</div>
              <Input
                className={css.modalInput}
                placeholder="请再次输入新密码"
                onChange={(event) => {
                  newPwdConfirm.current = event.target.value
                }}
                type="password"
                maxLength={20}
                minLength={6}
              />
            </div>
          </div>
        </Modal>
      </ConfigProvider>
    </Card>
  )
}

export default MyBasicInfo
